<div
  *ngIf="viewingSessionBlocked"
  class="session-overlay"
  (click)="$event.stopPropagation()"
>
  <h3>
    <mat-icon>visibility_off</mat-icon>
    Account wird bereits verwendet!
  </h3>
  <p>
    Das Video konnte nicht abgespielt werden weil der Account
    bereits auf zu vielen Geräten aktiv ist!
  </p>
</div>
<div *ngIf="!videoCanPlay"
     (click)="onPaywallClick($event)"
     class="paywall">
</div>
<div *ngIf="hasPreview() && !previewClicked && !autostart"
     class="video-player-preview" (click)="onPreviewClick()">
  <lib-lazy-image [picture]="video.preview"
                  [imgUrl]="video.preview_url"
                  [lazyLoad]="false"
                  alt="Video thumbnail"></lib-lazy-image>
  <span class="video-player-play-btn">
    <mat-icon>play_circle</mat-icon>
  </span>
</div>
<div *ngIf="!hasPreview() || previewClicked || autostart"
     inViewport
     [inViewportOptions]="{ threshold: 0.5 }"
     (inViewportAction)="onIntersect($event)"
     class="video-player-wrapper">
  <ng-template #bitmovinPlayer></ng-template>
</div>
